var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/NavigationModelRepo/navigationModelRepoConnect.ts";
import "core-js/modules/es.array.concat.js";
import { NavigationModelRepoFolder } from './NavigationModelRepoFolder';
import { Project } from './Project';
export function navigationModelRepoConnect(fetchService) {
  NavigationModelRepoFolder.fetchRootFolders.use(function (_ref) {
    var projectUrn = _ref.projectUrn;
    return fetchService.get("/v1/model-repo/project/".concat(projectUrn, "/folders")).then(NavigationModelRepoFolder.fetchRootFolders.toPromise);
  });
  NavigationModelRepoFolder.fetchFolderContent.use(function (_ref2) {
    var folderUrn = _ref2.folderUrn,
        projectUrn = _ref2.projectUrn;
    return fetchService.get("/v1/model-repo/project/".concat(projectUrn, "/folders/").concat(folderUrn, "/content")).then(NavigationModelRepoFolder.fetchFolderContent.toPromise);
  });
  Project.fetchList.use(function () {
    return fetchService.get("/v1/model-repo/project").then(Project.fetchList.toPromise);
  });
}